/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Specification } from './Specification';
import {
    SpecificationFromJSON,
    SpecificationFromJSONTyped,
    SpecificationToJSON,
} from './Specification';

/**
 * 
 * @export
 * @interface VariantOption
 */
export interface VariantOption {
    /**
     * 
     * @type {string}
     * @memberof VariantOption
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof VariantOption
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof VariantOption
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof VariantOption
     */
    imageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof VariantOption
     */
    sortOrder?: number;
    /**
     * 
     * @type {string}
     * @memberof VariantOption
     */
    groupId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof VariantOption
     */
    translatedSpecifications?: Array<string>;
    /**
     * 
     * @type {Specification}
     * @memberof VariantOption
     */
    specifications?: Specification;
}

/**
 * Check if a given object implements the VariantOption interface.
 */
export function instanceOfVariantOption(value: object): boolean {
    return true;
}

export function VariantOptionFromJSON(json: any): VariantOption {
    return VariantOptionFromJSONTyped(json, false);
}

export function VariantOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): VariantOption {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
        'groupId': json['groupId'] == null ? undefined : json['groupId'],
        'translatedSpecifications': json['translatedSpecifications'] == null ? undefined : json['translatedSpecifications'],
        'specifications': json['specifications'] == null ? undefined : SpecificationFromJSON(json['specifications']),
    };
}

export function VariantOptionToJSON(value?: VariantOption | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'imageUrl': value['imageUrl'],
        'sortOrder': value['sortOrder'],
        'groupId': value['groupId'],
        'translatedSpecifications': value['translatedSpecifications'],
        'specifications': SpecificationToJSON(value['specifications']),
    };
}

